/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getThreadedP2pPaymentStatsInternal} from '../api'

 export const useQueryGetThreadedP2pPaymentStatsInternal = createReactQueryHook('getThreadedP2pPaymentStatsInternal', getThreadedP2pPaymentStatsInternal)
